import { samsungGalaxcityData } from './SamsungStore';
import './SamsungStore.css';
import { useNavigate } from 'react-router-dom';

const SamsungGalaxyList = () => {
  const navigate = useNavigate();
  return (
    <div className="samsung-galaxy-list">
      <div className="samsungstore-title">
        {/* <p>
         Samsung  <strong> Store</strong>
        </p> */}
      </div>
      <div className="samsung-galaxy-list-wrapper">
        {samsungGalaxcityData.map((item) => (
          <div
            className="samsung-galaxy-list-item"
            key={item.id}
            // style={{ backgroundImage: `url(${item?.image})` }}
            style={{ display: 'flex', alignItems: 'center' }}
            onClick={() => navigate(`/applestore/products-list/${item.type}`)}
          >
            <img
              className="samsung-galaxy-list-img"
              src={item.image}
              alt={item.model}
            />
            <p className="samsung-galaxy-list-title">{item.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SamsungGalaxyList;
